var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("w-select", {
        attrs: {
          value: _vm.val,
          items: _vm.statusList,
          label: _vm.label,
          fancy: "",
        },
        on: {
          input: function ($event) {
            return _vm.setVal($event)
          },
        },
      })
    : _c("w-multi-select", {
        attrs: {
          value: _vm.val,
          items: _vm.statusList,
          label: _vm.label,
          fancy: "",
        },
        on: {
          input: function ($event) {
            return _vm.setVal($event)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }